import React, { useState, useEffect, useRef } from "react";
import loadingSpin from "../images/loadingSpin.gif";
import AccordionLayout from "./Accordion";
import axios from "axios";
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import Card from './common/Card';
import EmptyContent from "../components/common/EmptyContent";
import moment from "moment";
import ButtonLightBlue from "./common/ButtonLightBlue";
import ModalDefault from "./ModalDefault";


const AccordionMessage = () => {
    const [result, setResult] = useState([])
    const [loading, setLoading] = useState(false);
    const [fetchedNotes, setFetchedNotes] = useState([]);
    const [fetchError, setFetchError] = useState(false);

    const studentInfo = JSON.parse(localStorage.getItem('studentInfo'));
    const FathersEmail = studentInfo[0].FathersEmail;
    const GuardianEmail = studentInfo[0].GuardianEmail;
    const parentemail = studentInfo[0].parentemail;

    const MotherEmail = studentInfo[0].MotherEmail;
    // const idx = JSON.parse(localStorage.getItem('subSchoolData')).idx;
    // const FathersEmail = JSON.parse(localStorage.getItem('studentInfo')).FathersEmail;
    // const GuardianEmail  = JSON.parse(localStorage.getItem('studentInfo')).GuardianEmail
    // const parentemail = JSON.parse(localStorage.getItem('FathersEmail'))


    const [activeIndex, setActiveIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const modalId = 'message-modal';
    const [selectedMessage, setSelectedMessage] = useState(null);
    const displayMessageModal = (messageData) => {
        setSelectedMessage(messageData);
        setShowModal(true);
        setTimeout(() => document.querySelector('#' + modalId).scrollIntoView(), 50);
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedMessage(null);
    };

    const schoolDomain = localStorage.getItem('schoolDomain');

    const [iframeHeight, setIframeHeight] = useState(1000);

    const addLoadEventListenerScript = (message) => {
        return message.replace('</body>', `
            <script type="text/javascript">
                parent.window.postMessage(document.body.scrollHeight + 50, '*');
                document.querySelectorAll('[href]').forEach(elem => elem.setAttribute('target', '_blank'))
            </script>

            </body>
        `);
    };

    useEffect(() => {
        const subSchoolData = JSON.parse(localStorage.getItem('subSchoolData') ?? '{}');

        let Params = {
            "SchoolUrl": schoolDomain,
            "parentEmail": {
                "parentEmail": parentemail,
                "fatherEmail": FathersEmail,
                "motherEmail": MotherEmail,
                "guardianEmail": GuardianEmail,
            },
            "schDeploymentid": subSchoolData?.idx ?? 1,
        };

        setLoading(true);

        axios
            .post(
                "https://devapi.edves.net/testapi/public/v1/communication",
                JSON.stringify(Params),
            )
            .then(
                (response) => {
                    setLoading(false)
                    setResult(response.data.data)
                    console.log(response.data)
                    response.data.data.length > 0 && setFetchedNotes(response.data.data[0].Available_Notes);
                },
                (error) => {
                    console.log(error);
                    setFetchError(true);
                }
            );

        window.addEventListener('message', (e) => setIframeHeight(e?.data ?? 550) , '*');
    }, []);

    if (loading) {
        return (
            <div className='flex justify-center w-full h-full my-24'>
                <img src={loadingSpin} alt='loading...' />
            </div>
        );
    }

    if (fetchedNotes && fetchedNotes.length === 0 && !loading && !fetchError) {
        return (
            <div className='flex justify-center w-full sm:mt-16'>
                <EmptyContent message='No Communication Found' moreMessage='Communication made will be displayed here' />
            </div>
        );
    }

    return (
        <>
            {result.map((item, index) => (
                <Card className="mb-8" key={index}>
                    <div className="border-b flex justify-between p-4 text-gray-400 border-gray-600 text-sm">
                        <span>From: {item.fromname}</span>
                        <span className="text-right">
                            {moment(item.timestp).format('Do MMMM YYYY')}
                        </span>
                    </div>
                    <div className="p-4 flex justify-between items-start">
                        <div className="pr-2 text-sm font-semibold">{item.messagesubject}</div>
                        <div>
                            <ButtonLightBlue onClick={() => displayMessageModal(item)}>View message</ButtonLightBlue>
                        </div>
                    </div>
                </Card>

            ))}

            {showModal && (
                <ModalDefault onClose={closeModal} id={modalId}>
                    <div className="border-b flex justify-between p-2 text-gray-400 border-gray-500 text-sm mb-3">
                        <span>From: {selectedMessage.fromname}</span>
                        <span className="text-right">
                            {moment(selectedMessage.timestp).format('Do MMMM YYYY')}
                        </span>
                    </div>

                    <div class="pb-1" style={{height: `${iframeHeight}px`}}>
                        <iframe id='message-frame' style={{ height: 'inherit', width: "100%" }} srcDoc={addLoadEventListenerScript(selectedMessage.message)} />
                    </div>
                    <div className="flex justify-end p-3">
                        <ButtonLightBlue onClick={closeModal}>Close message</ButtonLightBlue>
                    </div>
                </ModalDefault>
            )}
        </>
    );
};

export default AccordionMessage;
